<div
  class="notes-to-ops-container"
  [ngClass]="getContainerClass()"
  [ngStyle]="getRootStyle()"
  >
  <!-- Header with Title and Controls -->
  <ng-container *ngTemplateOutlet="filterDialog"></ng-container>

  <!-- Chat Interface Container -->
  <div class="chat-interface-container" [ngStyle]="getChatInterfaceContainerStyle()">
    <!-- Add New Note Section - TOP POSITION -->
    @if (finalConfig && finalConfig.allowAdd && finalConfig.fieldsPosition === 'top') {
      <div>
        <ng-container *ngTemplateOutlet="noteEditor"></ng-container>
      </div>
    }

    @if (uniqueUsers.length > 1 && finalConfig.showUserFilters) {
      <div class="user-multiselect px-2">
        <p-multiSelect
          [options]="userOptions"
          [(ngModel)]="selectedUsers"
          dropdownIcon="fa fa-caret-down"
          [ngModelOptions]="{standalone: true}"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          placeholder="Filter by Users"
          display="chip"
          [style]="{'width': '100%'}"
          [styleClass]="'form-control form-control-sm'">
        </p-multiSelect>
      </div>
    }

    <!-- Chat Messages -->
    <div
      class="chat-messages-container mt-2"
      [ngStyle]="getMessagesContainerStyle()"
      >
      @if (managingNote && (!notes || notes.length === 0)) {
        <div class="text-center text-muted py-4">
          <i class="pi pi-spin pi-spinner me-2"></i>Loading notes...
        </div>
      }

      @if (!managingNote && getFilteredNotes().length === 0) {
        <div
          class="no-messages text-center text-muted py-4"
          >
          {{ finalConfig.emptyNotesText }}
        </div>
      }

      @if (!managingNote || (managingNote && notes && notes.length > 0)) {
        @for (note of getFilteredNotes(); track note; let i = $index) {
          <div class="chat-message" [ngStyle]="getNoteMessageStyle(note)">
            <div class="d-flex justify-content-between">
              <div class="message-header">
                <div class="d-flex flex-column">
                  @if (note.title) {
                    <span class="fw-bold mb-1" style="font-size: 14px; color: #333;">{{ note.title }}</span>
                  }
                  <div>
                    <span class="message-timestamp fw-bold">{{ note.dateTime | date: 'MMM dd, yyyy hh:mm a' }},</span>
                    <span class="sender-name fw-bold ms-1">{{ note.employee }} wrote :</span>
                  </div>
                </div>
              </div>
              <div class="message-meta">
                <span class="badge rounded-pill me-2" [style.background-color]="getNoteTypeColor(note.noteType)"
                  [style.color]="getTextColorForBackground(getNoteTypeColor(note.noteType))"
                  [style.font-weight]="'bold'">
                  {{ getNoteTypeName(note.noteType) }}
                </span>
                <span class="badge rounded-pill me-2" [style.background-color]="getStatusColor(note.status)"
                  [style.color]="getTextColorForBackground(getStatusColor(note.status))"
                  [style.font-weight]="'bold'">
                  {{ getStatusName(note.status) }}
                </span>
                @if (finalConfig.allowEdit) {
                  <i class="fa fa-pencil action-icon me-2" (click)="editNote(note)"
                  [title]="finalConfig.editButtonText"></i>
                }
                @if (finalConfig.allowDelete) {
                  <i class="fa fa-trash action-icon" (click)="deleteNote(note)"
                  [title]="finalConfig.deleteButtonText"></i>
                }
              </div>
            </div>
            <div class="message-content">
              @if (!note.isExpanded && isNoteLong(note)) {
                <span [innerHTML]="getNotePreviewAsHtml(note)"></span><span>...</span>
              }
              @if (note.isExpanded || !isNoteLong(note)) {
                <span [innerHTML]="getNoteContentAsHtml(note)"></span>
              }
              @if (isNoteLong(note)) {
                <a
                  href="javascript:void(0)"
                  class="read-more-link ms-2"
                  (click)="toggleNoteExpansion(note)"
                  >
                  {{ note.isExpanded ? 'Read Less' : 'Read More' }}
                </a>
              }
            </div>
          </div>
        }
      }
    </div>

    <!-- Add New Note Section - BOTTOM POSITION -->
    @if (finalConfig && finalConfig.allowAdd && finalConfig.fieldsPosition === 'bottom') {
      <div>
        <ng-container *ngTemplateOutlet="noteEditor"></ng-container>
      </div>
    }
  </div>
</div>


<ng-template #noteEditor let-idSuffix="idSuffix">
  <div class="add-note-section">
    <div class="d-flex flex-column gap-2" [formGroup]="notesForm">

      <!-- Title Field -->
      <input pInputText type="text" class="w-100" placeholder="Title"
        formControlName="newNoteTitle" />

      <!-- Rich text editor (when useRichTextEditor is true) -->
      @if (finalConfig?.useRichTextEditor) {
        <div class="textarea-with-button">
          <editor formControlName="newNoteText" [id]="getEditorId(idSuffix)" [init]="tinyMceConfig"></editor>
          <button type="button" class="btn btn-success send-inside" (click)="addNewNote()"
            [disabled]="managingNote || isSubmitting || !canSubmitNote()"
            [title]="isEditingNote ? 'Update Note' : 'Send Note'" aria-label="Send note">
            @if (!managingNote && !isSubmitting) {
              <span>
                <i class="fa fa-paper-plane"></i>
              </span>
            }
            @if (managingNote || isSubmitting) {
              <span>
                <i class="pi pi-spin pi-spinner"></i>
              </span>
            }
          </button>
        </div>
      }

      @if (!finalConfig?.useRichTextEditor) {
        <div class="textarea-with-button">
          <textarea
            [id]="'newNoteText-' + instanceId"
            name="newNoteText"
            [rows]="finalConfig?.noOfRows || 2"
            class="w-100 pe-5 pb-3"
            pInputTextarea
            [autoResize]="true"
            [placeholder]="finalConfig.placeholder"
            formControlName="newNoteText"
          (keydown.enter)="addNewNote()"></textarea>
          <button type="button" class="btn btn-success send-inside" (click)="addNewNote()"
            [disabled]="managingNote || isSubmitting || !canSubmitNote()"
            [title]="isEditingNote ? 'Update Note' : 'Send Note'" aria-label="Send note">
            @if (!managingNote && !isSubmitting) {
              <span>
                <i class="fa fa-paper-plane"></i>
              </span>
            }
            @if (managingNote || isSubmitting) {
              <span>
                <i class="pi pi-spin pi-spinner"></i>
              </span>
            }
          </button>
        </div>
      }

      <!-- Fields -->
      <div class="d-flex gap-2">
        <div class="flex-grow-1">
          <p-dropdown
            [options]="finalConfig.noteTypes"
            formControlName="newNoteType"
            optionLabel="name"
            optionValue="value"
            placeholder="Note Type"
            styleClass="w-100"
            dropdownIcon="fa fa-caret-down"
            appendTo="body"
            [filter]="false"
            filterBy="name"
            [showClear]="false"
          ></p-dropdown>
        </div>

        <div class="flex-grow-1">
          <p-dropdown
            [options]="finalConfig.statusOptions"
            formControlName="newNoteStatus"
            optionLabel="name"
            optionValue="value"
            placeholder="Status"
            styleClass="w-100"
            dropdownIcon="fa fa-caret-down"
            appendTo="body"
            [filter]="false"
            filterBy="name"
            [showClear]="false"
          ></p-dropdown>
        </div>

        @if (isEditingNote) {
          <div class="d-flex align-items-end">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelEdit()">
              {{ finalConfig.cancelButtonText }}
            </button>
          </div>
        }
      </div>

    </div>
  </div>
</ng-template>


<ng-template #filterDialog>
  @if (finalConfig?.showHeader) {
    <li class="list-group-item list-group-label text-end">
      <div class="d-flex align-items-center justify-content-between gap-2">
        <div class="fw-bold text-black">
          {{ finalConfig.title}}
          @if (getFilteredNotes().length > 0) {
            <span>
            ({{ getFilteredNotes().length }})</span>
          }
        </div>
        <div class="position-relative d-flex gap-2">
          <!-- Sort Button -->
          @if (finalConfig.showSortOptions) {
            <button type="button" class="btn btn-outline-secondary btn-sm"
              (click)="toggleSortOrder()" [title]="getSortTooltip()">
              <i [ngClass]="getSortIcon()"></i>
            </button>
          }
          <!-- Filter Button -->
          @if (finalConfig.showFilters) {
            <button type="button"
              class="btn btn-outline-secondary btn-sm dropdown-toggle position-relative" (click)="toggleFilterDropdown()"
              title="Filter Notes">
              <i class="fa fa-filter"></i>
              @if (getActiveFilterCount() > 0) {
                <span
                  class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                  style="font-size: 0.6rem">
                  {{ getActiveFilterCount() }}
                </span>
              }
            </button>
          }
          <!-- Fullscreen Button -->
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openFullscreen()" title="{{showFullscreen ? 'Close Full Screen' : 'Open Full Screen'}}"
            aria-label="{{showFullscreen ? 'Close Full Screen' : 'Open Full Screen'}}">
            <i class="fa" [ngClass]="showFullscreen ? 'fa-compress' : 'fa-expand'"></i>
          </button>
          <!-- Filter Dropdown -->
          @if (showFilterDropdown && finalConfig.showFilters) {
            <div
              class="filter-dropdown position-absolute bg-white border rounded shadow-sm"
              style="top: 100%; right: 0; min-width: 300px; z-index: 1000; margin-top: 5px">
              <div class="p-3" [formGroup]="filterForm">
                @for (filter of finalConfig.availableFilters; track filter) {
                  <div>
                    <label class="form-label small">{{ filter.label }}</label>
                    <!-- Text Input -->
                    @if (filter.type === 'text') {
                      <input type="text" class="form-control form-control-sm"
                        [placeholder]="'Filter by ' + filter.label.toLowerCase()" [formControlName]="filter.key" />
                    }
                    <!-- Select Input -->
                    @if (filter.type === 'select') {
                      <select class="form-select form-select-sm" [formControlName]="filter.key">
                        <option value="">All {{ filter.label }}</option>
                        @for (option of getFilterOptions(filter.key); track option) {
                          <option [value]="option.value">
                            {{ option.name }}
                          </option>
                        }
                      </select>
                    }
                    <!-- Date Input -->
                    @if (filter.type === 'date') {
                      <input type="date" class="form-control form-control-sm"
                        [formControlName]="filter.key" />
                    }
                  </div>
                }
                <div class="d-flex gap-2 mt-3">
                  <button type="button" class="btn btn-primary btn-sm flex-fill" (click)="applyFilters()">
                    Apply
                  </button>
                  <button type="button" class="btn btn-outline-secondary btn-sm flex-fill" (click)="clearFilters()">
                    Clear
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </li>
  }
</ng-template>


<!-- Confirmation Dialog -->
<!-- <p-confirmDialog></p-confirmDialog> -->

<!-- Fullscreen Dialog -->
<p-dialog [(visible)]="showFullscreen" [modal]="true" [dismissableMask]="true" [draggable]="false"
  [resizable]="false" [style]="{ width: '100vw', height: '100vh', maxWidth: '2000px', maxHeight: '100vh' }" [contentStyle]="{ height: 'calc(90vh - 3rem)' }"
  [breakpoints]="{ '960px': '95vw', '640px': '98vw' }" [baseZIndex]="10000" header="{{ finalConfig.title }}" [showHeader]="false">
  <div>
    <button type="button" class="btn btn-light position-absolute top-0 end-0 m-3" (click)="closeFullscreen()"
      aria-label="Close">
      <i class="pi pi-times" style="font-size: 1.5rem;"></i>
    </button>
  </div>
  <div class="fullscreen-container">
    <div class="my-2 mt-4 d-flex align-items-center justify-content-between gap-2">
      <div class="w-50">
        <ng-container *ngTemplateOutlet="filterDialog"></ng-container>
      </div>

      @if (finalConfig && finalConfig.allowAdd) {
        <button
          type="button"
          class="btn btn-primary btn-sm me-5"
          (click)="openFullscreenEditorForAdd()">
          <i class="fa fa-plus me-1"></i>Add Note
        </button>
      }

    </div>

    <div class="fullscreen-chat d-flex" style="height:100%;">
      <div class="flex-grow-1 d-flex flex-column" style="min-width:0; min-height:0;">
        <div class="chat-messages-container-full-width mt-2" [ngStyle]="getMessagesContainerStyle(true)">
          @if (managingNote && (!notes || notes.length === 0)) {
            <div class="text-center text-muted py-4">
              <i class="pi pi-spin pi-spinner me-2"></i>Loading notes...
            </div>
          }

          @if (!managingNote && getFilteredNotes().length === 0) {
            <div class="no-messages text-center text-muted py-4">
              {{ finalConfig.emptyNotesText }}
            </div>
          }

          @if (!managingNote || (managingNote && notes && notes.length > 0)) {
            <div class="overflow-y-auto fullscreen-note-list">
              <p-table
                #fsNotesTable
                [value]="getFilteredNotes()"
                [paginator]="true"
                [rows]="10"
                [rowsPerPageOptions]="[10, 20, 50]"
                sortMode="multiple"
                [globalFilterFields]="['title', 'employee', 'notes']"
                >
                <ng-template pTemplate="caption">
                  <div class="d-flex justify-content-start">
                    <span class="p-input-icon-right w-50">
                      <i class="pi pi-search"></i>
                      <input
                        pInputText
                        type="text"
                        class="w-100"
                        (input)="fsNotesTable.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="Search notes" />
                    </span>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="dateTime">Date <p-sortIcon field="dateTime"></p-sortIcon></th>
                    <th pSortableColumn="employee">User <p-sortIcon field="employee"></p-sortIcon></th>
                    <th pSortableColumn="title">Title <p-sortIcon field="title"></p-sortIcon></th>
                    <th pSortableColumn="notes">Message <p-sortIcon field="notes"></p-sortIcon></th>
                    <th pSortableColumn="noteType">Type <p-sortIcon field="noteType"></p-sortIcon></th>
                    <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
                    <th>Actions</th>
                  </tr>
                  <tr>
                    <th><p-columnFilter field="dateTime" type="date" matchMode="dateIs"></p-columnFilter></th>
                    <th><p-columnFilter field="employee" type="text" matchMode="contains"></p-columnFilter></th>
                    <th><p-columnFilter field="title" type="text" matchMode="contains"></p-columnFilter></th>
                    <th><p-columnFilter field="notes" type="text" matchMode="contains"></p-columnFilter></th>
                    <th><p-columnFilter field="noteType" type="text" matchMode="contains"></p-columnFilter></th>
                    <th><p-columnFilter field="status" type="text" matchMode="contains"></p-columnFilter></th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-note>
                  <tr [ngStyle]="getNoteMessageStyle(note)">
                    <td>{{ note.dateTime | date: 'MMM dd, yyyy hh:mm a' }}</td>
                    <td>{{ note.employee }}</td>
                    <td>{{ note.title || '-' }}</td>
                    <td>
                      @if (!note.isExpanded && isNoteLong(note)) {
                        <span>
                          {{ getNotePreview(note) }}...
                        </span>
                      }
                      @if (note.isExpanded || !isNoteLong(note)) {
                        <span [innerHTML]="getNoteContentAsHtml(note)"></span>
                      }
                      @if (isNoteLong(note)) {
                        <a href="javascript:void(0)" class="read-more-link ms-2"
                          (click)="toggleNoteExpansion(note)">
                          {{ note.isExpanded ? 'Read Less' : 'Read More' }}
                        </a>
                      }
                    </td>
                    <td>
                      <span class="badge rounded-pill me-2" [style.background-color]="getNoteTypeColor(note.noteType)"
                        [style.color]="getTextColorForBackground(getNoteTypeColor(note.noteType))" [style.font-weight]="'bold'">
                        {{ getNoteTypeName(note.noteType) }}
                      </span>
                    </td>
                    <td>
                      <span class="badge rounded-pill me-2" [style.background-color]="getStatusColor(note.status)"
                        [style.color]="getTextColorForBackground(getStatusColor(note.status))" [style.font-weight]="'bold'">
                        {{ getStatusName(note.status) }}
                      </span>
                    </td>
                    <td class="text-nowrap">
                      @if (finalConfig.allowEdit) {
                        <i class="pi pi-pencil action-icon me-2 fs-5"
                        (click)="openFullscreenEditorForEdit(note)" [title]="finalConfig.editButtonText"></i>
                      }
                      @if (finalConfig.allowDelete) {
                        <i class="pi pi-trash action-icon fs-5"
                        (click)="deleteNote(note)" [title]="finalConfig.deleteButtonText"></i>
                      }
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</p-dialog>

@if (showFullscreenEditor) {
  <p-dialog
    [(visible)]="showFullscreenEditor"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [appendTo]="'body'"
    [style]="{ width: '60vw', maxWidth: '900px' }"
    [breakpoints]="{ '960px': '85vw', '640px': '95vw' }"
    (onHide)="closeFullscreenEditor()"
    [header]="isEditingNote ? 'Edit Note' : 'Add Note'">
    <ng-container *ngTemplateOutlet="noteEditor; context: { idSuffix: 'fs-edit' }"></ng-container>
  </p-dialog>
}